import { render, staticRenderFns } from "./WasteCollectItemDrawer.vue?vue&type=template&id=20d44405&scoped=true&"
import script from "./WasteCollectItemDrawer.vue?vue&type=script&lang=js&"
export * from "./WasteCollectItemDrawer.vue?vue&type=script&lang=js&"
import style0 from "./WasteCollectItemDrawer.vue?vue&type=style&index=0&id=20d44405&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d44405",
  null
  
)

export default component.exports